import storageKeys from '../../data/storageKeys';

const getUserLocation = () => {
  const userLocation =
    typeof window !== 'undefined' ? JSON.parse(localStorage.getItem(storageKeys.userCoordinates)) || {} : {};
  const userLocationExists = !!(userLocation.latitude && userLocation.longitude);
  return [userLocationExists, userLocation];
};

export { getUserLocation };
